export default __webpack_public_path__ + "static/admin-link-e922f0cb.svg";